export const getLanguageName = (languageCode: string): string | undefined => {
    try {
        return new Intl.DisplayNames(['en'], { type: 'language' }).of(languageCode)
    } catch (e) {
        // uppercase the first letter of the language code
        return languageCode.toLowerCase().charAt(0).toUpperCase() + languageCode.slice(1)
    }
}
